module.exports = __webpack_public_path__ + "static/media/exportar.a5544611.png";